import { render, staticRenderFns } from "./InteractMessage.vue?vue&type=template&id=29770c13"
import script from "./InteractMessage.vue?vue&type=script&lang=js"
export * from "./InteractMessage.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/youtube/yt-live-chat-interact-message-renderer.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports